import styled, { css } from 'styled-components';

export const Item = styled.li`
  display: grid;
  position: relative;
  user-select: text;
  ${(props) =>
    props.chatType === 'bot' &&
    css`
      max-width: 80%;
      margin-right: auto;
      grid-template-columns: 50px 1fr;
    `}
  ${(props) =>
    props.chatType === 'user' &&
    css`
      max-width: 80%;
      margin-left: auto;
      grid-template-columns: 1fr 50px;
    `}
  max-width: initial;
`;

export const ChatBubbleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.chatType === 'user' &&
    css`
      align-items: flex-end;
    `}
  ${(props) =>
    props.chatType === 'bot' &&
    css`
      align-items: flex-start;
    `}
  padding: 0px 1rem;
  ${(props) =>
    props.feedbackText !== '' &&
    css`
      width: 100%;
    `}
`;

export const ChatNameWrapper = styled.div`
  margin-bottom: 0.5rem;
  max-width: 8rem;
  line-height: 1rem;
`;

export const ChatBubbleFeedbackWrapper = styled.div`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: var(--secondary-color);
  border-radius: 0px 16px 16px 16px;
  margin: -1rem 0rem 0rem;
  padding: 1.4rem 1rem 0.3rem 1rem;
  color: #fff;
  font-weight: 400;
  cursor: pointer;
  gap: 0.4rem;
`;

export const ChatBubbleFeedbackTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ChatBubbleFeedbackTitle = styled.p`
  font-weight: 500;
  text-align: left;
`;

export const ChatBubbleFeedbackContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1rem;
  grid-template-rows: 1fr 1rem;
  justify-content: flex-start;
  gap: 5px;
  padding-bottom: 0.6rem;
`;

export const ChatBubbleFeedbackContentText = styled.div`
  font-weight: 400;
  text-align: left;
  word-break: break-word;
`;

export const ChatBubbleFeedbackIconExpand = styled.div`
  transform: rotate(90deg);
  justify-self: flex-end;
  width: 1rem;
  height: 1rem;
`;

export const ChatBubbleFeedbackIconCollapse = styled.div`
  transform: rotate(270deg);
  justify-self: flex-end;
  grid-column: 2;
  grid-row: 2;
`;

export const IsAIIconWrapper = styled.div`
  position: absolute;
  top: -6px;
  left: -2px;
  cursor: help;
`;
